import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { CircularProgress } from "../components/CircularProgress/CircularProgress";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

type ConfirmStatus = "loading" | "success" | "error";

export const ConfirmEmail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<ConfirmStatus>("loading");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      setStatus("error");
      setError("Некорректная ссылка подтверждения");
      return;
    }

    let cancelled = false;

    axios
      .get(`/auth/confirm/${id}`)
      .then(() => {
        if (!cancelled) {
          setStatus("success");
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setStatus("error");
          setError(getApiErrorMessage(err, "Не удалось подтвердить email"));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return (
    <div className="auth-container">
      <div className="auth-floating-wrap">
        <Link to="/" className="auth-home-link auth-home-link--floating" aria-label="На главную">
          <ArrowLeft size={14} />
          <span className="auth-home-link-label">На главную</span>
        </Link>
        <div className="auth-form">
          <h1 className="auth-title">I N A R I</h1>
          {status === "loading" && (
            <div className="button-wrapper">
              <CircularProgress size="lg" />
            </div>
          )}
          {status === "success" && (
            <>
              <div className="footer-links">
                <span className="auth-link" style={{ cursor: "default" }}>
                  Ваш email подтверждён
                </span>
              </div>
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => navigate("/login")}
              >
                Войти в систему
              </button>
            </>
          )}
          {status === "error" && (
            <>
              <div className="form-error">{error}</div>
              <button className="btn btn-primary" type="button" onClick={() => navigate("/login")}>
                Войти в систему
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
